import type inventoryEn from "./inventory.en";

const inventoryAr: Record<keyof typeof inventoryEn, string> = {
  "nav.inventory": "المخزون",
  "nav.transfers": "عمليات النقل",
  "nav.purchase_orders": "أوامر الشراء",
  "settings.locations": "المستودعات",
  "settings.locations_hint": "المستودعات والمتاجر ونقاط الاستلام",
  "settings.inventory": "المخزون",
  "settings.inventory_hint": "الحجوزات وتنبيهات انخفاض المخزون",
  "inv.title": "المخزون",
  "inv.all_locations": "كل المواقع",
  "inv.search": "ابحث بالمنتج أو رمز SKU أو الباركود",
  "inv.filter.low": "مخزون منخفض",
  "inv.filter.out": "نفد المخزون",
  "inv.col.product": "المنتج",
  "inv.col.sku": "رمز SKU",
  "inv.col.unavailable": "غير متاح",
  "inv.col.committed": "محجوز لطلبات",
  "inv.col.available": "متاح",
  "inv.col.on_hand": "في المخزن",
  "inv.col.incoming": "وارد",
  "inv.untracked": "غير متتبَّع",
  "inv.edit_needs_location": "اختر موقعًا لتعديل الكميات.",
  "inv.save_changes": "حفظ {n} تغييرات",
  "inv.saved": "تم تحديث المخزون",
  "inv.history": "سجل التعديلات",
  "inv.history_empty": "لا توجد تغييرات بعد.",
  "inv.import": "استيراد",
  "inv.export": "تصدير",
  "inv.import_title": "استيراد الكميات",
  "inv.import_hint": "ملف CSV يحتوي على أعمدة SKU (أو الباركود) والموقع والمتاح. صدّر أولًا للحصول على ملف جاهز.",
  "inv.import_set": "استبدال الكميات (تعيين المتاح إلى قيمة الملف)",
  "inv.import_adjust": "تعديل الكميات (إضافة قيمة الملف)",
  "inv.import_done": "حُدّث {updated}، فشل {failed}",
  "inv.counts": "جرد المخزون",
  "inv.empty_title": "لا يوجد شيء لجرده بعد",
  "inv.empty_body": "أضف منتجات لتتبع مخزونها هنا.",
  "inv.move": "نقل وحدات",
  "inv.qty": "الكمية",
  "inv.from": "من",
  "inv.to": "إلى",
  "inv.track": "تتبع الكمية",
  "inv.threshold": "تنبيه انخفاض المخزون عند",
  "inv.store_default": "الإعداد الافتراضي للمتجر",
  "inv.per_location": "الكمية حسب الموقع",
  "inv.total_available": "{n} متاح",
  "inv.breakdown": "تفاصيل المخزون",
  "state.available": "متاح",
  "state.committed": "محجوز لطلبات",
  "state.reserved": "محجوز مؤقتًا",
  "state.incoming": "وارد",
  "state.damaged": "تالف",
  "state.safety_stock": "مخزون احتياطي",
  "state.quality_control": "فحص الجودة",
  "reason.received": "استلام",
  "reason.correction": "تصحيح",
  "reason.sale": "بيع",
  "reason.return_restock": "إرجاع إلى المخزون",
  "reason.damaged": "تلف",
  "reason.shrinkage": "سرقة أو فقدان",
  "reason.transfer_out": "نقل صادر",
  "reason.transfer_in": "نقل وارد",
  "reason.reservation": "حجز أثناء الدفع",
  "reason.reservation_release": "إلغاء الحجز",
  "reason.fulfillment": "تم التسليم",
  "reason.cycle_count": "جرد",
  "reason.promotion": "عرض ترويجي",
  "reason.movement": "نقل بين الحالات",
  "reason.other": "أخرى",
  "loc.intro": "المواقع هي الأماكن التي تخزّن فيها المنتجات وتُجهّز منها الطلبات: متجر أو مستودع أو منزلك.",
  "loc.empty": "لا توجد مواقع بعد.",
  "loc.details": "تفاصيل الموقع",
  "loc.name_hint": "يظهر للعملاء عند الاستلام من هنا.",
  "loc.fulfillment": "تجهيز الطلبات",
  "loc.fulfils_hint": "يمكن تجهيز الطلبات الإلكترونية من مخزون هذا الموقع.",
  "loc.fulfils_short": "يجهّز الطلبات الإلكترونية",
  "loc.pickup_title": "الاستلام من الموقع",
  "loc.pickup_badge": "استلام",
  "loc.pickup_hint": "يمكن للعملاء اختيار استلام طلبهم من هنا عند إتمام الشراء.",
  "loc.pickup_instructions_hint": "تُرسل مع إشعار جاهزية الاستلام، مثل المواقف أو ساعات العمل.",
  "loc.ready.1h": "ساعة واحدة",
  "loc.ready.2h": "ساعتان",
  "loc.ready.4h": "4 ساعات",
  "loc.ready.24h": "24 ساعة",
  "loc.ready.2d": "يومان",
  "loc.ready.5d": "5 أيام",
  "loc.id": "معرّف الموقع",
  "loc.copy_id": "نسخ معرّف الموقع",
  "loc.id_hint": "استخدمه كقيمة location_id عند تحديث المخزون عبر الواجهة البرمجية.",
  "loc.inventory": "المخزون",
  "loc.stocked_items": "أصناف متوفرة",
  "loc.stock_summary": "{items} صنف · {units} وحدة",
  "loc.view_inventory": "عرض مخزون هذا الموقع",
  "loc.status": "الحالة",
  "loc.active_hint": "نشط: يمكن بيع المخزون هنا وتعديله.",
  "loc.inactive_hint": "غير نشط: لا يُباع المخزون هنا. فعّله لاستخدامه مجددًا.",
  "loc.deactivate_title": "إيقاف {name}؟",
  "loc.deactivate_body": "لن يُحتسب مخزونه ضمن الكميات المتاحة للبيع. يمكنك تفعيله لاحقًا.",
  "loc.deactivated": "أُوقف الموقع.",
  "loc.activated": "فُعّل الموقع.",
  "loc.delete_body": "سيُحذف الموقع نهائيًا، ويبقى سجله في سجل المخزون.",
  "loc.delete_has_stock": "انقل مخزونه أو أزله قبل الحذف.",
  "loc.title": "المواقع",
  "loc.add": "إضافة موقع",
  "loc.name": "اسم الموقع",
  "loc.address1": "العنوان",
  "loc.address2": "الشقة أو المبنى",
  "loc.city": "المدينة",
  "loc.region": "المنطقة",
  "loc.postal": "الرمز البريدي",
  "loc.country": "رمز الدولة",
  "loc.phone": "الهاتف",
  "loc.fulfils": "تجهيز الطلبات الإلكترونية من هذا الموقع",
  "loc.pickup": "إتاحة الاستلام من هنا",
  "loc.pickup_instructions": "تعليمات الاستلام",
  "loc.pickup_ready": "يكون جاهزًا عادةً خلال",
  "loc.inactive": "غير نشط",
  "loc.deactivate": "إيقاف",
  "loc.activate": "تفعيل",
  "loc.delete_confirm": "حذف {name}؟",
  "invset.reserve_at": "حجز المخزون للعملاء",
  "invset.reserve_checkout": "عند وصولهم إلى خطوة الدفع (موصى به)",
  "invset.reserve_order": "عند تقديم الطلب فقط",
  "invset.reservation_minutes": "مدة الحجز (بالدقائق)",
  "invset.threshold": "حد انخفاض المخزون (افتراضي)",
  "invset.digest": "أرسل لي ملخصًا يوميًا بالمنتجات منخفضة المخزون",
  "tr.title": "عمليات النقل",
  "tr.add": "إنشاء عملية نقل",
  "tr.origin": "من الموقع",
  "tr.destination": "إلى الموقع",
  "tr.expected": "تاريخ الوصول المتوقع",
  "tr.reference": "رقم التتبع / المرجع",
  "tr.notes": "ملاحظات",
  "tr.items": "العناصر",
  "tr.add_items": "إضافة عناصر",
  "tr.status.draft": "مسودة",
  "tr.status.in_transit": "قيد النقل",
  "tr.status.partially_received": "مستلم جزئيًا",
  "tr.status.received": "مستلم",
  "tr.status.cancelled": "ملغي",
  "tr.ship": "تعيين كقيد النقل",
  "tr.receive": "استلام العناصر",
  "tr.accept": "قبول",
  "tr.reject": "رفض",
  "tr.remaining": "المتبقي",
  "tr.cancel": "إلغاء النقل",
  "tr.cancel_confirm": "إلغاء عملية النقل؟ تعود الوحدات غير المستلمة إلى الموقع الأصلي.",
  "tr.empty": "انقل المخزون بين مواقعك عبر عمليات النقل.",
  "tr.received_of": "استُلم {received} من {total}",
  "po.title": "أوامر الشراء",
  "po.add": "إنشاء أمر شراء",
  "po.supplier": "المورّد",
  "po.no_supplier": "بدون مورّد",
  "po.new_supplier": "مورّد جديد",
  "po.destination": "الوجهة",
  "po.currency": "العملة",
  "po.terms": "شروط الدفع",
  "po.expected": "تاريخ الوصول المتوقع",
  "po.shipping": "الشحن",
  "po.reference": "الرقم المرجعي",
  "po.notes": "ملاحظات للمورّد",
  "po.cost": "التكلفة",
  "po.subtotal": "المجموع الفرعي",
  "po.total": "الإجمالي",
  "po.status.draft": "مسودة",
  "po.status.ordered": "تم الطلب",
  "po.status.partially_received": "مستلم جزئيًا",
  "po.status.received": "مستلم",
  "po.status.closed": "مغلق",
  "po.status.cancelled": "ملغي",
  "po.mark_ordered": "تعيين كمطلوب",
  "po.receive": "استلام المخزون",
  "po.update_cost": "تحديث تكلفة المنتج (المتوسط المرجّح)",
  "po.close": "إغلاق أمر الشراء",
  "po.close_confirm": "إغلاق أمر الشراء؟ لن تُنتظر العناصر غير المستلمة.",
  "po.pdf": "تنزيل PDF",
  "po.empty": "اطلب المخزون من المورّدين واستلمه في أحد مواقعك.",
  "po.supplier_name": "اسم المورّد",
  "po.contact_name": "اسم جهة الاتصال",
  "po.email": "البريد الإلكتروني",
  "po.phone": "الهاتف",
  "count.title": "جرد المخزون",
  "count.add": "بدء جرد",
  "count.name": "الاسم",
  "count.location": "الموقع",
  "count.scan": "امسح أو أدخل الباركود / SKU",
  "count.scan_hint": "يكتب ماسح الباركود في هذا الحقل. كل مسح يضيف وحدة واحدة.",
  "count.camera": "المسح بالكاميرا",
  "count.camera_stop": "إيقاف الكاميرا",
  "count.camera_unsupported": "هذا المتصفح لا يدعم مسح الباركود بالكاميرا. استخدم ماسحًا أو اكتب الرمز.",
  "count.expected": "المتوقع",
  "count.counted": "المعدود",
  "count.variance": "الفرق",
  "count.apply": "تطبيق الجرد",
  "count.apply_confirm": "تطبيق فروق الجرد على المخزون؟",
  "count.cancel": "إلغاء الجرد",
  "count.status.open": "مفتوح",
  "count.status.applied": "مطبّق",
  "count.status.cancelled": "ملغي",
  "count.progress": "عُدّ {counted} من {total}",
  "count.empty": "اجرد مخزونك لتصحيح الفروق بين النظام والرفوف.",
  "count.scanned": "{title}: {counted}",
  "picker.title": "إضافة عناصر",
  "picker.add": "إضافة {n}",
};

export default inventoryAr;
